<template>
  <b-row>
    <b-col cols="12">
      <div class="d-flex justify-content-end my-1">
        <b-button v-if="HasPermission(PermissionList.Sales_Create)" variant="primary" @click="sendQuote()">
          <span class="text-nowrap">Add Quotation</span>
        </b-button>
      </div>
    </b-col>
    <!-- search input -->
    <b-col md="2" sm="4" class="my-1">
      <b-form-group class="mb-0">
        <label class="d-inline-block text-sm-left mr-50">Per page</label>
        <b-form-select id="perPageSelect" v-model="perPage" size="sm" :options="pageOptions" class="w-50" />
      </b-form-group>
    </b-col>
    <b-col cols="12" class="d-flex justify-content-end mb-2" style="position: relative; z-index: 1;">
      <b-button variant="outline-danger" size="sm" @click="clearFilters">
        Clear Filters
      </b-button>
    </b-col>

    <b-col cols="12">
      <b-table striped hover responsive :per-page="perPage" :current-page="currentPage" :items="filteredQuotations"
        :fields="fields" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :filter="filter"
        :filter-included-fields="filterOn" @filtered="onFiltered">

        <!-- QUOTATION NO Filter -->
        <template #head(quotationNo)="scope">
          <div class="d-flex flex-column">
            <span>Quotation No</span>
            <b-form-input v-model="filters.quotationNo" placeholder="Search Quotation No" size="sm"
              @input="filterTable" />
          </div>
        </template>

        <!-- PRIORITY Filter -->
        <template #head(priority)="scope">
          <div class="d-flex flex-column">
            <span>Priority</span>
            <b-form-select v-model="filters.priority" :options="[
              { value: null, text: 'All' },
              { value: 'High', text: 'High' },
              { value: 'Medium', text: 'Medium' },
              { value: 'Low', text: 'Low' }
            ]" @input="filterTable" size="sm" />
          </div>
        </template>

        <!-- CREATED ON Filter -->
        <template #head(createdOn)="scope">
          <div class="d-flex flex-column">
            <span>Created On</span>
            <DatePicker v-model="filters.createdOnRange" range format="YYYY-MM-DD" placeholder="Select date range"
              @change="filterTable" style="width: 100%;" size="sm" />
          </div>
        </template>

        <!-- DUE DATE Filter -->
        <template #head(dueDate)="scope">
          <div class="d-flex flex-column">
            <span>Due Date</span>
            <DatePicker v-model="filters.dueDateRange" range format="YYYY-MM-DD" placeholder="Select date range"
              @change="filterTable" style="width: 100%;" size="sm" />
          </div>
        </template>

        <template #head(status)="scope">
          <div class="d-flex flex-column">
              <span>STATUS</span>
              <b-form-select
                v-model="filters.status"
                @input="filterTable"
                size="sm"
              >
                <option value="">All</option>
                <option value="NEW">NEW</option>
                <option value="PROFORMA">PROFORMA</option>
              </b-form-select>
            </div>
        </template>

        <template #cell(total)="data">
          Rs {{ data.item.total.toFixed(2) }}
        </template>
        <template #cell(isActive)="data">
          <b-badge v-if="data.item.isActive" variant="primary"> Active </b-badge>
          <b-badge v-else variant="danger"> Inactive </b-badge>
        </template>
        <template #cell(orderType)="data">
          <!-- <b-badge v-if="data.item.orderType === 0" variant="primary">
            Fixed Order
          </b-badge> -->
          <b-badge v-if="data.item.orderType === 1" variant="primary">
            Variable Order
          </b-badge>
          <b-badge v-else-if="data.item.orderType === 2" variant="primary">
            OneOff Order
          </b-badge>
        </template>
        <template #cell(createdOn)="data">
          {{ convertTimestampToDate(data.item.createdOn) }}
        </template>
        <template #cell(dueDate)="data">
          {{ convertTimestampToDate(data.item.dueDate) }}
        </template>
        <!-- <template #cell(status)="data">
          <b-badge v-if="data.item.status === 0" variant="secondary"> New </b-badge>
          <b-badge v-else-if="data.item.status === 1" variant="warning">
            Pending
          </b-badge>
          <b-badge v-else-if="data.item.status === 2" variant="primary">
            Completed
          </b-badge>
          <b-badge v-else variant="danger"> Blocked </b-badge>
        </template> -->
        <!-- Display status as Badge in Table -->
        <template #cell(status)="data">
            <b-badge v-if="data.item.status === 0" variant="secondary"
              >New</b-badge
            >
            <b-badge v-else-if="data.item.status === 3" variant="info"
              >Proforma</b-badge
            >
          </template>
        <template #cell(actions)="data">
          <div class="d-flex">
          <b-button v-if="HasPermission(PermissionList.Sales_View)" :to="getQuotationView(data.item.id)" variant="success" class="mr-2">
            <feather-icon icon="EyeIcon" size="16" class="text-body align-middle mr-25" />
            View
          </b-button>
          <b-button
            v-if="HasPermission(PermissionList.Sales_Update) && data.item.status === 0"
            :to="getQuotationEdit(data.item.id)"
            variant="info"
          >
            <feather-icon icon="Edit2Icon" size="16" class="text-body align-middle mr-1" />
            Edit
          </b-button>
        </div>
        </template>
      </b-table>
      <div class="d-flex justify-content-center mb-1">
        <b-alert variant="warning" show v-if="quotations.length === 0" class="d-flex justify-content-center">
          <h4 class="alert-heading">No Quotations yet</h4>
        </b-alert>
      </div>
    </b-col>

    <b-col cols="12">
      <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="center" size="sm"
        class="my-0" />
    </b-col>
  </b-row>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import {
  BTable,
  BAvatar,
  BAlert,
  BBadge,
  BRow,
  BCol,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BSpinner,
  BDropdown,
  BDropdownItem,
} from "bootstrap-vue";
import { PermissionList } from '@/libs/defaultList';
import { HasPermission } from '@/@core/utils/validations/permissionCheck';
import { mapActions, mapGetters } from "vuex";
export default {
  components: {
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BSpinner,
    BDropdown,
    BDropdownItem,
    BAlert,
    DatePicker
  },
  data() {
    return {
      id: this.$route.params.id,
      leadClientName: "",
      total: "",
      dueDate: "",
      isActive: 1,
      status: "",
      //salesOrderData: [],
      quotationData: [],
      perPage: 5,
      pageOptions: [3, 5, 10],
      totalRows: 1,
      currentPage: 1,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
      fields: [
        { key: "quotationNo", label: "QUOTATION NO", sortable: true },
        { key: "priority", label: "PRIORITY", sortable: true },
        { key: "total", label: "TOTAL", sortable: true },
        { key: "createdOn", label: "CREATED ON", sortable: true },
        { key: "dueDate", label: "DUE DATE", sortable: true },
        { key: "status", label: "STATUS", sortable: true },
        "actions",
      ],
      filters: {
        quotationNo: '',
        priority: null,
        createdOnRange: [null, null],
        dueDateRange: [null, null],
        status: '',
      },
    };
  },
  computed: {
    filteredQuotations() {
      return this.quotations.filter((quotation) => {
        const matchesQuotationNo = !this.filters.quotationNo ||
          (quotation.quotationNo && quotation.quotationNo.toLowerCase().includes(this.filters.quotationNo.toLowerCase()));
        const matchesPriority = this.filters.priority === null ||
          quotation.priority === this.filters.priority;
        const matchesCreatedOn =
          !this.filters.createdOnRange[0] ||
          !this.filters.createdOnRange[1] ||
          (new Date(quotation.createdOn) >= new Date(this.filters.createdOnRange[0]) &&
            new Date(quotation.createdOn) <= new Date(this.filters.createdOnRange[1]));
        const matchesDueDate =
          !this.filters.dueDateRange[0] ||
          !this.filters.dueDateRange[1] ||
          (new Date(quotation.dueDate) >= new Date(this.filters.dueDateRange[0]) &&
            new Date(quotation.dueDate) <= new Date(this.filters.dueDateRange[1]));
            const matchesStatus = !this.filters.status || 
          this.getStatusText(quotation.status) === this.filters.status;

        return matchesQuotationNo && matchesPriority && matchesCreatedOn && matchesDueDate && matchesStatus;
      });
    },

    anyFilterActive() {
      const { quotationNo, customer, customerEmail, salesPerson, dueDate, createdOn, status } = this.filters;
      return (
        quotationNo || customer || customerEmail || salesPerson || dueDate || createdOn || status
      );
    },
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => ({ text: f.label, value: f.key }));
    },
    ...mapGetters("salesOrderModule", {
      salesOrderList: "salesorders",
      loading: "loading",
    }),

    ...mapGetters("leadModule", {
      quotations: "quotations",
      loading: "loading",
    }),
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.quotations.length;
  },
  methods: {

    filterTable() {
      this.currentPage = 1;
      this.totalRows = this.filteredQuotations.length;
    },

    clearFilters() {
      this.filters = {
        quotationNo: '',
        priority: null,
        createdOnRange: [null, null],
        dueDateRange: [null, null],
        status: "",
      };
      this.filterTable;
    },

    getStatusText(status) {
      switch (status) {
        case 0:
          return "NEW";
        case 3:
          return "PROFORMA";
      }
    },

    sendQuote() {
      this.$router.push("/quotation/add/" + this.$route.params.id);
    },
    convertTimestampToDate(timestamp) {
      return new Date(timestamp).toLocaleDateString();
    },
    getsalesOrderData(data) {
      console.log(data);
      this.quotationData = data;
    },
    getQuotationEdit(item) {
      return "/quotation/edit/" + item;
    },
    getQuotationView(item) {
      return "/quotation/preview/" + item;
    },

    removesalesOrder(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.removeSalesOrdersAction(id);
          this.$swal({
            icon: "success",
            title: "Deleted!",
            text: "Your file has been deleted.",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        } else if (result.dismiss === "cancel") {
          this.$swal({
            title: "Cancelled",
            text: "Your file is safe :)",
            icon: "error",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.infoModal.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    ...mapActions("salesOrderModule", [
      "getSalesOrdersListAction",
      "removeSalesOrdersAction",
    ]),
    ...mapActions("leadModule", ["getLeadQuotationsAction"]),
  },
  async mounted() {
    await this.getLeadQuotationsAction(this.id)
      .then(() => {
        this.totalRows = this.quotations.length;
      })
      .catch((response) => {
        console.log(response);
      });
  },
  setup(props) {
    return {
      PermissionList,
      HasPermission
    }
  }
};
</script>
